import { type IApiResponse } from '@/helpers/types';
import { getCommandQuery, type IGetQuery } from '@/store/actions/api-utils';

import { coreApiSlice } from '../apiSlice';

interface IPresidingOfficer {
	id: number;
	userId: number;
	poolingUnitId: number;
	electionId: number;
}

const presidingOfficerApiSlice = coreApiSlice.injectEndpoints({
	endpoints: (builder) => ({
		createPresidingOfficer: builder.mutation<IApiResponse, Omit<IPresidingOfficer, 'id'>>({
			query: (body) => ({
				method: 'POST',
				url: '/PresidingOfficer',
				body,
			}),
		}),
		getPresidingOfficier: builder.query<IApiResponse<IPresidingOfficer[]>, IGetQuery>({
			query: ({ paged, query }) => ({
				url: `/PresidingOfficer${getCommandQuery(paged, ...(query || []))}`,
			}),
		}),
		getPresidingOfficierPollingUnit: builder.query<IApiResponse, { userId: string }>({
			query: ({ userId }) => ({
				url: `/PresidingOfficer/PollingUnitDetails?userId=${userId}`,
			}),
		}),
		getPresidingOfficierById: builder.query<IApiResponse, { id: string }>({
			query: ({ id }) => ({
				url: `/PresidingOfficer/${id}`,
			}),
		}),
		updatePresidingOfficier: builder.mutation<IApiResponse, IPresidingOfficer>({
			query: (body) => ({
				url: '/PresidingOfficer/update',
				method: 'PUT',
				body,
			}),
		}),
		deletePresidingOfficer: builder.mutation<IApiResponse, { id: string }>({
			query: ({ id }) => ({
				url: `/PresidingOfficer/delete/${id}`,
				method: 'DELETE',
			}),
		}),
	}),
});

export const {
	useCreatePresidingOfficerMutation,
	useDeletePresidingOfficerMutation,
	useGetPresidingOfficierByIdQuery,
	useLazyGetPresidingOfficierByIdQuery,
	useGetPresidingOfficierPollingUnitQuery,
	useLazyGetPresidingOfficierPollingUnitQuery,
	useGetPresidingOfficierQuery,
	useLazyGetPresidingOfficierQuery,
	useUpdatePresidingOfficierMutation,
} = presidingOfficerApiSlice;
